require('@buss/nav-search');
require('@third/jquery-cookie');
require('@third/respond');
require('@third/jquery-lazyload');
require('@cnpm/ie-shim/json');
require('@cnpm/ie-shim/bind');
require('@buss/searchbox-channel');
require('@buss/suggest');
require('@cnpm/es6-promise').polyfill();
var Utils = require('@cnpm/utils');

/*eslint camelcase: "warn"*/
/*global __webpack_public_path__:true*/
/**
 * 定义 webpack publicPath 值
 * 当执行异步获取组件文件时提供文件绝对地址
 */
__webpack_public_path__ = Utils.getScriptAbsoluteDir();
var Signin = require('@buss/signin');
var ChangeStyle = require('@buss/change-style');

var bubbleIpad = require('./bubble_ipad.js');
var ItemConvert = require('./item_convert.js');
// var SiteEdit = require('./mysite_index.js');
// var ResizeMainHeight = require('./resize_main_height.js');
var hotTrace  = require('./hotTrace.js');
hotTrace.init();
var hotSearch  = require('./hotSearch.js');
hotSearch.init();
var weather  = require('./weather.js');
weather.init();
var mShowHide = require('./mShowHide.js');
var showHideCard = require('./show_hide_card.js');
var Startmarquee = require('./startmarquee.js');
var listPowerNice = require('./list_power_nice.js');
var changeStyle = new ChangeStyle({
    settingStyleCallback: function (data) {
       $('#js_image_from').text(data.source).parent().show();
    }
});
var signin = new Signin();
var Big5Shim = require('@buss/big5-shim');
var scrollbar = require('./jquery.scrollbar.js');

changeStyle.initialize();
signin.initialize();

require('./fixed.js');
require('./Rolling_news_right.js');

require('../css/chinaso_index.css');
require('../css/weather.css');

/**
 * 页面用到引用的功能组件
 * 滚动热搜词
 * ipad气泡提示
 * 搜索框相关功能
 * 显示或隐藏页面功能卡片
 * 重置 main 组件高度
 * 头条列表的相关功能:调用列表加载公共js,添加【新】字样.
 */
var ListPowerNice;
function init() {
  var startMarquee1;
  var startMarquee2;
  var $newsA;

  bubbleIpad();
  // searchInput();
  // SiteEdit.init();
  // ResizeMainHeight.initialize();
  mShowHide();
  showHideCard();
  ListPowerNice = new listPowerNice();

  // 滚动热搜词
  startMarquee1 = new Startmarquee(30, 30, 4000);
  startMarquee1.slide();
  // 滚动热搜词 右侧
  startMarquee2 = new Startmarquee(30, 30, 4000, 'chinaso_keyword_ul');
  startMarquee2.slide();

  $('#nav_wrapper').show();
  //新闻频道手机端打开pc版本
  if (window.getQueryStringRegExp('path') === 'www') {
    $newsA = $('#nav_wrapper span a').eq(0);
    $newsA.attr('href', $newsA.attr('href') + '?path=www');
  }

  //繁体版
  window.onload = function(){
      if(window.location.hostname.indexOf('big5.chinaso.com') > -1){
          $("#simpleHref").mouseover(function(){
              $(this).attr("href", "http"+":/"+"/"+"www.chinaso.com/new/index.html");
          })
      }
  };
}

//图片懒加载
function imageInit() {
  $('img[data-original]').lazyload({
    event: 'scroll',
    //threshold: 200,
    //failure_limit: 200,
    skip_invisible: true
  });
  $(document).on('sporty', 'img[data-original]', function () {
    var $cur = $(this);
    var original = $cur.data('original');
    if ($cur.attr('src') !== original) {
      $cur.attr('src', original);
    }
  });
  $('.qieHuanCont').on('sporty', 'img[data-original]', function () {
    var $cur = $(this);
    var original = $cur.data('original');
    if ($cur.attr('src') !== original) {
      $cur.attr('src', original);
    }
  });
  $('.main-slide-pic img').trigger('sporty');
}

// tab 切换功能实例，提供外部适配引用
// 在我的网址功能中使用到，暂停自动切换
// window.autoPlayInstance
function tabInit() {
  // 获得距离顶部距离
  // 用来 tab 切换时定位到 tab content 最上端
  var qieHuanWrapv3 = $('.qieHuanWrap-v3');
  var top = qieHuanWrapv3.offset().top;
  // var qieHuanWrapv3 = qieHuanWrap.find('.qieHuanWrap-v3');
  // var qhwHeight = qieHuanWrapv3.outerHeight();
  // tab标签切换
  // 网友在热搜
  window.autoPlayInstance = new ItemConvert({
    container: '.qieHuanWrap-v3',
    item: $('.qieHuanNav li'),
    content: '.qieHuanCont .qieHuan',
    cur: 'cur',
    isAutoPlay: false, //false/true
    autoSpeed: 4000,
    events: 'click',
    preCallback: function preCallback() {
      var csbHeight;
      // 如果定位打开，切换 tab 后定位 tab content 最上端
      if (qieHuanWrapv3.css('position') === 'fixed') {
        csbHeight = $('.chinaso-search-box').outerHeight();
        $(window).scrollTop((top - csbHeight) + 1);
      }
    },
    callback: function callback(/** itemIndex */) {
      $(".scrollDiv").scrollbar({contentCls:"scrollUl"});
      // 切换新标签时触发内容图片加载
      $('.qieHuanCont img').trigger('sporty');

      // 触发屏幕 main 组件高度变化
      $('.indexMain').trigger('main:resizeHeight');
      // $(window).trigger('scroll');
      if ($('.qieHuan:eq(0)').is(':visible') && $('.toutiao_l_list').size() > 3 && $('.toutiao_l_list').size() <= 5 && $(window).height() < 1020 || $('.qieHuan:eq(0)').is(':visible') && $('.toutiao_l_list').size() > 5) {
        $('.footer_index').attr('style', 'position:static');
      } else {
        $('.footer_index').attr('style', 'position:absolute');
      }
      if ($('.qieHuan:eq(1)').is(':visible')) {
        hotTrace.autoPlay();
      } else {
        hotTrace.stopPlay();
      }
    }
  });
}

/**
 * 简繁体转换
 */
function traditionalHref() {
  var url = Big5Shim.reverseURL(window.location.href);
  var text = Big5Shim.reverseText('%E7%AE%80%E4%BD%93%E7%89%88', '繁體版');
  $('#traditionalHref').attr('href', url).text(text);
}

function ensure() {
  // 登录组件
  // require.ensure([], function requireSignin(require) {
    // require('@buss/signin');
  // });

  // IE 旧版本提示组件
  // require.ensure([], function requireIeOldTip(require) {
    require('@cnpm/ie-shim/ie-old-tip');
  // });

  // 手机国搜二维码展示组件
  // require.ensure([], function requireAppCode(require) {
    require('@buss/app-code').create();
  // });

  // 设为主页组件
  // require.ensure([], function requireAppCode(require) {
    require('@cnpm/set-home');
  // });

  // 换肤组件
  // require.ensure([], function requireAppCode(require) {
    // require('@buss/change-style');
  // });

  // require.ensure([], function requireAppCode(require) {
    require('@cnpm/faceback');
  // });
}

scrollbar(window, jQuery);
ensure();
init();
imageInit();
tabInit();

//焦点新闻是否向下滚动过
window.isScroll = false;
//焦点新闻滚动鼠标显示更多
$(document).on('mousewheel DOMMouseScroll', function(e){
  if($('.qieHuan:eq(0)').is(':visible') && !isScroll){
    var delta = (e.originalEvent.wheelDelta && (e.originalEvent.wheelDelta > 0 ? 1 : -1)) ||  // chrome & ie
    (e.originalEvent.detail && (e.originalEvent.detail > 0 ? -1 : 1));              // firefox
    if(delta<0){//向下滚动
      ListPowerNice.rollList.send();
      $('.toutiao_l_list').show();
      $('.more_news').hide();
      // $('.footer_index').attr('style','position:static');
      // $('.loading').show();
      // isScroll = true;
    }   
  }
});

$(document).on('scroll', function(e){
  if($('.qieHuan:eq(0)').is(':visible') && !isScroll){
    ListPowerNice.rollList.send();
    $('.toutiao_l_list').show();
    $('.more_news').hide();
    // $('.footer_index').attr('style','position:static');
    // isScroll = true;
  }
});

//more点击显示更多
$('.more_news').one('click', function() {
  // if($('.toutiao_l_list:hidden').size() != 0) {
    ListPowerNice.rollList.send();
    $('.toutiao_l_list').show();
    // $('.footer_index').attr('style','position:static');
    // $('.loading').show();
    $(this).hide();
    // isScroll = true;
  // }
})

//返回顶部
$('.gotop').on('click', function(){
  $('body,html').animate({ scrollTop: 0 }, 200);
})
$(window).scroll(function() {
  if ($(window).scrollTop() > $(window).height() *2) {
      $('.gotop').fadeIn(200);
  } else {
      $(".gotop").fadeOut(200);
  }
});

//导航显示
$('.nav_icon').on('click', function() {
  if($('.search_nav ul').is(':hidden')){
    var state = "true";
  } else{
    var state = "false";
  }
  $('.search_nav ul').toggle();
  $.cookie('__WWW_nav__DISSTATUS__', state, { expires: 365 });
})
// 默认隐藏导航
if(typeof $.cookie('__WWW_nav__DISSTATUS__') === 'undefined'){$.cookie('__WWW_nav__DISSTATUS__', 'false', { expires: 365 });}
if ($.cookie('__WWW_nav__DISSTATUS__') == 'true') {
  $('.search_nav ul').show();
}

//地方频道入口交互
$('#nav_difang').hover(function(){
  $('.difang_con').show();
}, function(){
  $('.difang_con').hide();
});

setTimeout(function () {
  // require('@cnpm/vtoolbar');
});
traditionalHref();



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/index.js
// module id = 60da270a38df6aee8984
// module chunks = 1